import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import Theme from 'Theme';
import Icons from 'components/Icons';

const check = keyframes`
  0%   {opacity: 0; }
  50%  {opacity: 0.5; }
  100% {opacity: 1.0; }
`;

const scale = keyframes`
  0%   {transform: scale(0, 0);}
  50%  {transform: scale(1.2, 1.2);}
  100% {transform: scale(1, 1);}
`;

export const Input = styled.input`
  display: none;
`;

export const Contain = styled.div`
  display: flex;
  position: relative;
  align-items: center;
`;

export const Check = ({ checked }) => {
  return (
    <CheckContain checked={checked}>
      {checked && <Icons.Complete color={Theme.brandColor} />}
    </CheckContain>
  );
};

const CheckContain = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  top: 0px;
  left: 3px;
  transform: scale(0.85, 0.85);
  cursor: pointer;
  user-select: none;
  transition: all 0.3s ease-out;

  ${({ checked }) => checked && css`
    animation: ${scale} 0.3s ease-out;
  `};
`;

export const CheckIcon = styled.div`
  display: none;
  cursor: pointer;
  user-select: none;
  position: relative;
  transition: all 0.3s ease-out;
  width: 18px;
  height: 18px;
  border-radius: 0px;
  background-color: ${props => props.theme.brandColor};

 ${({ checked }) => checked && css`
    display: unset;
    animation: ${check} 0.3s ease-out;
  `};

`;

export const RadioDisplay = styled.div`
  height: 24px;
  width: 24px;
  display: flex;
  cursor: pointer;
  user-select: none;
  border-width: 2px;
  border-style: solid;
  align-items: center;
  background-color: #fff;
  justify-content: center;
  border-color: ${props => props.error
    ? Theme.dangerColor
    : Theme.lightMediumGrey
  };

  ${({ checked }) => checked && css`
    border-color: ${Theme.brandColor};
  `};
`;

export const Label = styled.label`
  margin-left: 8px;
  font-weight: 300;
  font-family: ${Theme.primaryFont};
`;
